// extracted by css-extract-rspack-plugin
export default {"link":"_cd889d0b","respTitle":"_108987f","respDescription":"_ee8d4f99","consumerBg":"_5ed72f50","tradeBg":"_1282dd08","mobileImage":"_e458892c","tradeButton":"_b78a5d5b"};